@switch (type()) {
  @case ('stroked') {
    <pt-loader-button
      type="stroked"
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [loading]="loading()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      {{ displayLabel() }}
    </pt-loader-button>
  }
  @case ('flat') {
    <pt-loader-button
      type="flat"
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [loading]="loading()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      {{ displayLabel() }}
    </pt-loader-button>
  }
  @case ('raised') {
    <pt-loader-button
      type="raised"
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [loading]="loading()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      {{ displayLabel() }}
    </pt-loader-button>
  }
  @default {
    <pt-loader-button
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [loading]="loading()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      {{ displayLabel() }}
    </pt-loader-button>
  }
}

@switch (type()) {
  @case ('stroked') {
    <button
      mat-stroked-button
      class="menu-button"
      [color]="color()"
      [disabled]="isDisabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
  @case ('flat') {
    <button
      mat-flat-button
      class="menu-button with-divider"
      [color]="color()"
      [disabled]="isDisabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
  @case ('raised') {
    <button
      mat-raised-button
      class="menu-button with-divider"
      [color]="color()"
      [disabled]="isDisabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
  @default {
    <button
      mat-button
      class="menu-button with-divider"
      [color]="color()"
      [disabled]="isDisabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
}

<mat-menu #menu="matMenu" xPosition="before" class="side-button-menu">
  <ng-content />
</mat-menu>
